import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    "Content-Type": "application/json",
  };
};

// =============================================
// Get next payment number (pure integer, per-business)
// =============================================
export const getNextPaymentNo = async (businessId) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Payment/get-next-payment-no`,
      { BusinessId: businessId },
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting next payment number:", error);
    throw error;
  }
};

// =============================================
// Get outstanding purchase invoices for a supplier
// =============================================
export const getSupplierOutstandingInvoices = async (
  supplierId,
  businessId,
  branchId = null
) => {
  try {
    const payload = { SupplierId: supplierId, BusinessId: businessId };
    if (branchId != null) payload.BranchId = branchId;

    const response = await axios.post(
      `${BASE_URL}/api/Payment/get-supplier-outstanding-invoices`,
      payload,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting supplier outstanding invoices:", error);
    throw error;
  }
};

// =============================================
// Save (insert / update) a payment
// =============================================
export const savePayment = async (paymentData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Payment/save-payment`,
      paymentData,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving payment:", error);
    throw error;
  }
};

// =============================================
// Get payments list (paginated)
// =============================================
export const getPayments = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Payment/get-payments`,
      filter,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting payments:", error);
    throw error;
  }
};

// =============================================
// Get a single payment with full details
// =============================================
export const getPaymentById = async (paymentId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/api/Payment/get-payment-by-id/${paymentId}`,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting payment by ID:", error);
    throw error;
  }
};

// =============================================
// Export Payments Summary to Excel
// =============================================
export const exportPaymentsSummary = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Payment/export-summary`,
      filter,
      { headers: getAuthHeader(), responseType: "blob" }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Payments_Summary_${Date.now()}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting payments summary:", error);
    throw error;
  }
};

// =============================================
// Export Payments Details to Excel
// =============================================
export const exportPaymentsDetails = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Payment/export-details`,
      filter,
      { headers: getAuthHeader(), responseType: "blob" }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Payments_Details_${Date.now()}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting payments details:", error);
    throw error;
  }
};

